import { FC } from 'react';

export const FallbackPageHelmet: FC = () => {
  return <></>;
};
